export default __webpack_public_path__ + "static/media/gallery17.72b15564.webp";